// extracted by mini-css-extract-plugin
export default {"dashboard":"DashboardPage_dashboard__ePDs4","searchButtons":"DashboardPage_searchButtons__6u1j3","fileInput":"DashboardPage_fileInput__bax3B"};